import { initializeApp } from "firebase/app";
import { getAuth } from "firebase/auth"
import { getFirestore } from "firebase/firestore"
import { getStorage } from "firebase/storage"

const firebaseConfig = {
  apiKey: "AIzaSyAL-8xK-90nFq3hVfDUPKQB-CBKlEbgUIY",
  authDomain: "managd-au.firebaseapp.com",
  projectId: "managd-au",
  storageBucket: "managd-au.firebasestorage.app",
  messagingSenderId: "511489803027",
  appId: "1:511489803027:web:1016310b31a8d6cc0210e6",
  measurementId: "G-SYRRKDKYVV"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);

export const db = getFirestore(app)
export const auth = getAuth(app)
export const storage = getStorage(app)